import { InclusionCode } from "@silversea-ssc/web-inclusions";

const expeditionsCodes = ["ExpeditionCruiseExtras", "FreeShorexExpedition"];

export const filterExpeditionInclisionsCodes = (inclusionCode: InclusionCode) =>
  !expeditionsCodes.includes(inclusionCode);

export const withExpeditionInclusionsCodes = (
  inclusionCodes: InclusionCode[]
) => inclusionCodes.some((x) => expeditionsCodes.includes(x));
